import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DECLINE_REASON_MAX } from '../../../models/reservation';

/** Who and what is being declined, for the dialog's sentence. */
export interface DeclineRequestData {
  guestName: string;
  partySize: number;
  /** "7:30 PM" or "Sat 31 Oct, 7:30 PM", already on the restaurant's clock. */
  when: string;
}

/** What the dialog closes with when the host declines; undefined when they keep it. */
export interface DeclineRequestResult {
  /** Trimmed; empty when the host gave none. */
  reason: string;
}

/**
 * Decline a booking request with an optional reason the guest is told
 * (FNF-308). ConfirmationDialogComponent takes no input, so this is its own
 * dialog in the same look. reservation-service accepts up to 200 characters.
 */
@Component({
  selector: 'app-decline-request-modal',
  standalone: true,
  imports: [MatDialogModule, FormsModule],
  templateUrl: './decline-request-modal.component.html',
  styleUrl: './decline-request-modal.component.css',
})
export class DeclineRequestModalComponent {
  readonly data = inject<DeclineRequestData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<DeclineRequestModalComponent, DeclineRequestResult>>(MatDialogRef);

  readonly maxLength = DECLINE_REASON_MAX;
  reason = '';

  get partyLabel(): string {
    return this.data.partySize === 1 ? '1 guest' : `${this.data.partySize} guests`;
  }

  decline(): void {
    this.dialogRef.close({ reason: this.reason.trim().slice(0, this.maxLength) });
  }
}

/** Opens the dialog; emits the result on Decline, undefined when the host keeps the request. */
export function askDeclineReason(
  dialog: MatDialog,
  data: DeclineRequestData,
): Observable<DeclineRequestResult | undefined> {
  return dialog
    .open<DeclineRequestModalComponent, DeclineRequestData, DeclineRequestResult>(
      DeclineRequestModalComponent,
      { data, maxWidth: '95vw' },
    )
    .afterClosed();
}
